import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const OverviewApi = createApi({
  reducerPath: "OverviewApi",
  baseQuery: authBaseQuery,
  tagTypes: [],
  endpoints: (builder) => ({
    getVendorBusinessTypes: builder.query({
      query: () => "v1/vendor_business_type",
      transformResponse: (res) => res?.data ?? [],
    }),

    getVendorById: builder.query({
      query: (id) => `v1/vendor/${id}`,
      transformResponse: (res) => res?.data ?? {},
    }),

    getBankDetailsByVendorId: builder.query({
      query: (id) => `v1/bank_details_by_vendor_id/${id}`,
      transformResponse: (res) => res?.data ?? [],
    }),

    getVendorGroupLinkById: builder.query({
      query: (id) => `v1/vendor_group_link_vendor_id/${id}`,
      transformResponse: (res) => res?.data ?? "",
    }),

    getCompanyByVendorId: builder.query({
      query: (id) => `v1/company_name_wise_vendor/${id}`,
      transformResponse: (res) => res?.data ?? {},
    }),

    checkVendorMobileUnique: builder.query({
      query: (mobile) => {
        return `v1/check_vendor_number_unique/${mobile}`;
      },
    }),
    getInfluencerData: builder.query({
      query: (pageName) => {
        return `v1/get_pages_with_profile?search=${encodeURIComponent(
          pageName
        )}`;
      },
    }),
  }),
});

export const {
  useGetVendorBusinessTypesQuery,
  useGetVendorByIdQuery,
  useGetBankDetailsByVendorIdQuery,
  useGetVendorGroupLinkByIdQuery,
  useGetCompanyByVendorIdQuery,
  useCheckVendorMobileUniqueQuery,
  useGetInfluencerDataQuery,
} = OverviewApi;

export default OverviewApi;
